import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col, Typography, Spin, List } from 'antd';
import Animate from 'rc-animate';
import ServiceItem from './ServiceItem';
import instance from '../../utils/API';
import axios from "axios";

const { Title,Text } = Typography;

const Services = () => {
    const user = useSelector(state => state.user)
    const {orders} = useSelector(state => state.orders)
    const history = useHistory()

    const [services, setServices] = useState([]);
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
  
    useEffect(() => {
        setLoading(true)

        axios.all([
                    instance(user.jwt).get("courses"), 
                    instance(user.jwt).get("services")
                ])
            .then(axios.spread((...responses) => {
                const responseCourses = responses[0]
                const responseServices = responses[1]
                responseCourses.data.map((course) =>{
                    orders.map(ord =>{
                        if((ord.type == "course") 
                            && (ord.status == "paid") 
                            && (ord.courseId == course.id) 
                        ){
                            course.available = true;
                        }
                    })

                    if(course.priceEur === 0){
                        course.available = true;
                    }
                    
                })

                setCourses(responseCourses.data)
                setServices(responseServices.data)
                setLoading(false);
            })).catch(errors => {
                setError(true);
                setLoading(false);
            })
    }, []);

    ///purchase/:type/:id
    const onBuyClick =(id)=>{
        history.push("/purchase/courses/" + id);
    }   
    ///course/:id
    const onStartCourse = (id)=>{
        history.push("/course/" + id);
    }

    return (
        <>
            <Row>
                <Title level={2}>
                    Services & Training 
                </Title>
            </Row>
            <Spin spinning={loading} delay={100} size="large">
            <Row gutter={[24,16]}>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12} >
                    <Animate
                        transitionName="fade"
                        transitionAppear
                    >
                        <List
                            size="small"
                            header={<Title level={5}>Education</Title>}
                            bordered
                            dataSource={courses}
                            renderItem={item => (
                                <List.Item >
                                        <Text type="secondary" >
                                            <b>{item.title}</b>
                                        </Text>
                                        { !item.available ? 
                                            <Button size="small"
                                             onClick={() => {onBuyClick(item.id)}}
                                            >
                                                Get for <b> € {item.priceEur}</b>
                                            </Button>
                                        : user.jwt ?
                                            <Button size="small" type="primary"
                                                 onClick={() => {onStartCourse(item.id)}}
                                             >
                                                Start Course
                                            </Button>
                                            :
                                            <Button size="small"
                                             onClick={() => {onBuyClick(item.id)}}
                                            >
                                                View Course
                                            </Button>
                                        }
                                </List.Item>
                            )}
                            style={{
                                borderRadius: 10, 
                                marginBottom: 25,
                                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                            }}
                        />
                    </Animate>
                    </Col>

                    {
                        services.map((service => (
                            <Col xs={24} sm={12} md={12} lg={6} xl={6} key={service.id}>
                            <Animate
                                transitionName="fade"
                                transitionAppear
                            >         
                                <ServiceItem  service={service}/>
                            </Animate>
                            </Col>
                        )))
                    }
            </Row>
            </Spin>
        </>
    )
}

export default Services
